import { render, staticRenderFns } from "./GoTopView.vue?vue&type=template&id=b3a3732a"
import script from "./GoTopView.vue?vue&type=script&lang=js"
export * from "./GoTopView.vue?vue&type=script&lang=js"
import style0 from "./GoTopView.vue?vue&type=style&index=0&id=b3a3732a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports